import React from 'react';
import { Calendar, FileText, ClipboardList } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { SquareButton, ButtonGridLayout } from '../components/ui';

/**
 * Página de captación de nuevos miembros
 */
export const Captacion: React.FC = () => {
  const navigate = useNavigate();

  /**
   * Maneja el click en el botón de disponibilidad
   */
  const handleDisponibilidad = () => {
    // TODO: Implementar navegación a disponibilidad
    setTimeout(() => {
      navigate('/disponibilidad');
    }, 200); // Delay para permitir la animación
  };

  /**
   * Maneja el click en el botón de partidos asignados
   */
  const handlePartidosAsignados = () => {
    setTimeout(() => {
      navigate('/partidos');
    }, 200); // Delay para permitir la animación
  };

  /**
   * Maneja el click en el botón de informes
   */
  const handleTusInformes = () => {
    setTimeout(() => {
      navigate('/tus-informes');
    }, 200); // Delay para permitir la animación
  };

  return (
    <div className="flex-1 p-4">
      <div className="space-y-6">
        <div className="bg-secondary-800 rounded-xl p-6 border border-secondary-700">
          <p className="text-secondary-400">
            Gestiona tú disponibilidad para el fin de semana, mira tus partidos asignados y crea informes.
          </p>
        </div>
        
        {/* Botones de navegación */}
        <ButtonGridLayout>
          <SquareButton
            icon={Calendar}
            text="Disponibilidad"
            onClick={handleDisponibilidad}
          />
          <SquareButton
            icon={ClipboardList}
            text="Partidos Asignados"
            onClick={handlePartidosAsignados}
          />
          <SquareButton
            icon={FileText}
            text="Tus Informes"
            onClick={handleTusInformes}
          />
        </ButtonGridLayout>
      </div>
    </div>
  );
};

export default Captacion;